<template>
  <div>
    <v-dialog v-model="dialog"
              persistent
              scrollable
              width="1100"
    >

      <v-card :loading="isLoading" :disabled="isLoading">

        <v-card-title>
          Cartes GIFTY
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">


          <v-simple-table v-if="account_cards.length" class="table-border rounded-lg">

            <template v-slot:default>
              <thead>
              <tr>
                <th>Statut</th>
                <th>Titre</th>
                <th>Services</th>
                <th>Clé</th>
                <th>Solde</th>
                <th>Solde à crédit</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(card ,index) in account_cards" :key="index">

                <td>
                  <v-switch v-model="card.is_active"
                            class="pa-0 ma-0"
                            color="success"
                            hide-details
                            readonly
                            @click="changeStatus(card.id)"></v-switch>
                </td>

                <td class="font-weight-medium text-no-wrap">
                  {{ card.name }}
                </td>

                <td class="text-no-wrap">

                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gifty"
                             text
                             small
                             rounded
                             class="v-btn--active"
                             v-bind="attrs"
                             v-on="on"
                      >
                        {{ card.services.length }}
                        <v-icon right>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                          v-for="service in card.services"
                          :key="service.id"
                      >
                        <v-list-item-title>
                          {{ service.name }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>


                <td class="font-weight-medium text-no-wrap">
                  <div class="bg-light rounded-lg pa-3 my-2">
                    {{ card.uuid }} &nbsp;
                    <v-icon @click="copy(card.uuid, card.id)" small color="gifty">
                      {{ copiedCardId === card.id ? "mdi-check" : "mdi-content-copy" }}
                    </v-icon>
                  </div>
                </td>


                <td class="font-weight-bold text-no-wrap">
                  {{ CurrencyFormatting(card.balance) }}
                </td>

                <td class="font-weight-bold text-no-wrap">
                  {{ CurrencyFormatting(card.credit_balance) }}
                </td>

                <td>
                  <div class="d-flex">
                    <v-btn icon color="gifty" disabled @click="$refs.addCardDialog.open()">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn icon color="gifty" @click="remove(card.id)">
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>

                    <v-menu left offset-y :close-on-content-click="false" v-model="card.menu"
                            min-width="400"
                            max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs"
                               v-on="on" color="gifty">
                          <v-icon>mdi-cash-plus</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="gifty white--text f-15">
                          Ajouter un solde
                          <v-spacer/>
                          <v-icon dark dense @click="card.menu = false">mdi-close</v-icon>
                        </v-card-title>

                        <v-card-subtitle class="gifty white--text f-14">
                          . {{ card.name }}
                        </v-card-subtitle>
                        <v-divider/>

                        <v-card-text class="pa-8">

                          <v-text-field outlined
                                        label="Solde"
                                        dense
                                        :error-messages="errors.balance"
                                        v-model="form.balance"></v-text-field>

                          <v-text-field outlined
                                        label="Solde à crédit"
                                        dense
                                        hide-details="auto"
                                        :error-messages="errors.credit_balance"
                                        v-model="form.credit_balance"></v-text-field>

                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                          <v-spacer/>
                          <v-btn dark
                                 color="gifty"
                                 :loading="btnLoading"
                                 depressed
                                 @click="addBalance(card)">
                            <v-icon left>mdi-send</v-icon>
                            Envoyer
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>

                  </div>
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card-text>
      </v-card>

    </v-dialog>

    <AddCardDialog ref="addCardDialog"/>
  </div>
</template>

<script>

import {HTTP} from "@/http-common";
import AddCardDialog from "./AddCardDialog";

export default {
  components: {AddCardDialog},
  data() {
    return {
      copiedCardId: null,
      btnLoading: false,
      isLoading: false,
      dialog: false,
      id: null,
      account_id: null,
      account_cards: [],
      errors: {},
      form: {},
    }
  },
  methods: {
    addBalance(card) {
      this.errors = {};
      this.btnLoading = true;
      HTTP.post("/v1/account-cards/add-balance", {
        account_card_id: card.id,
        balance: this.form.balance,
        credit_balance: this.form.credit_balance,
      }).then(() => {
        this.btnLoading = false;
        this.$successMessage = "Le solde a été ajouté avec succès!";
        card.menu = false

        if (this.form.balance && !isNaN(this.form.balance)) {
          const balance = parseFloat(this.form.balance);
          if (isFinite(balance)) {
            card.balance = (card.balance || 0) + balance;
          }
        }

        if (this.form.credit_balance && !isNaN(this.form.credit_balance)) {
          const credit = parseFloat(this.form.credit_balance);
          if (isFinite(credit)) {
            card.credit_balance = (card.credit_balance || 0) + credit;
          }
        }

        this.form = {};

      }).catch((err) => {
        this.errors = err.response.data.errors
        this.btnLoading = false;
        console.log(err);
      });
    },
    open(account) {
      this.dialog = true
      this.account_id = account?.id
      this.account_cards = account?.account_cards.map(card => ({
        ...card,
        menu: false
      }));

    },
    close() {
      this.dialog = false
      this.account_cards = this.account_cards.map(card => ({
        ...card,
        menu: false
      }));
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.isLoading = true;
      HTTP.delete("/v1/account-cards/" + this.id + "/delete").then(() => {
        this.isLoading = false;
        let i = this.account_cards.findIndex((el) => el.id === this.id);
        this.$delete(this.account_cards, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";

        if (!this.account_cards.length) {
          this.dialog = false
        }
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.isLoading = true;
      HTTP.post("/v1/account-cards/change-status", {
        id: id,
      }).then(() => {
        this.isLoading = false;
        let index = this.account_cards.findIndex(el => el.id === id)
        this.account_cards[index].is_active = !this.account_cards[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },

    copy(uuid, id) {
      navigator.clipboard.writeText(uuid).then(() => {
        this.copiedCardId = id;
        setTimeout(() => {
          this.copiedCardId = null;
        }, 1000);
      });
    },
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
  }
}
</script>

